import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = { class: "compare-container" }
const _hoisted_2 = { class: "filter-bar" }
const _hoisted_3 = { class: "charts-area" }
const _hoisted_4 = { class: "chart-title" }

import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import VChart from 'vue-echarts'
import { getPassLine, getUpDownDetailAnalysis } from '@/servers/api/analysis'
import { message } from 'ant-design-vue'
import { Card } from 'ant-design-vue'

// 1. 班级、学期、学生列表
type tableRuleProp = {
  score: number,
  line: number
}

// 3. 科目列表
interface ScoreItem {
  score: number | null;
  line: number | null;
}

interface SubjectData {
  x_name: string[];
  y_score: ScoreItem[];
}

interface TempDataType {
  [key: string]: SubjectData;
}

// 4. 查询结果

export default /*@__PURE__*/_defineComponent({
  __name: 'Compare',
  setup(__props) {

const studentList = ref<any[]>([])
const options = ref<any[]>([])
const selectedStudent = ref()
const messageReturn = ref<any[]>([])
const studentName = computed(() => {
  const stu = studentList.value.find(s => s.id === selectedStudent.value)
  return stu ? stu.name : ''
})

// 2. 查询方式
const mode = ref<'rank'|'score'>('score')

const subjects = ['总分','语文', '数学', '英语', '物理', '化学', '生物', '历史', '地理', '政治']
// 排名模式字段映射（扁平中文键：`${科目}段次`）
const fieldMappingRank = {
    '语文': '语文段次',
    '数学': '数学段次',
    '英语': '英语段次',
    '物理': '物理段次',
    '化学': '化学段次',
    '生物': '生物段次',
    '历史': '历史段次',
    '地理': '地理段次',
    '政治': '政治段次'
  }
  // 分数模式字段映射（扁平中文键：科目名）
const fieldMappingScore = {
    '语文': '语文',
    '数学': '数学',
    '英语': '英语',
    '物理': '物理',
    '化学': '化学',
    '生物': '生物',
    '历史': '历史',
    '地理': '地理',
    '政治': '政治'
  }
// 定义类型接口
const totalData = ref<TempDataType>({} as TempDataType)

// 5. 获取班级、学期、学生
onMounted(async () => {
  // 从localStorage中获取用户信息
  const userString = localStorage.getItem('user');
  if (!userString) {
    console.error('localStorage中没有找到用户信息。');
    messageReturn.value = [];
    return;
  }
  let userInfo: any;
  try {
    userInfo = JSON.parse(userString);
  } catch (e) {
    console.error('解析用户信息失败:', e);
    messageReturn.value = [];
    return;
  }

  if (!userInfo || !userInfo.role) {
    console.error('用户信息不完整或角色ID缺失。', userInfo);
    messageReturn.value = [];
    return;
  }

  const studentId = parseInt(userInfo.role);
  if (isNaN(studentId)) {
    console.error('学生ID无效:', userInfo.role);
    messageReturn.value = [];
    return;
  }

  // 查询学生近几次考试的成绩
  try {
    console.log('调用 getUpDownDetailAnalysis, student_id:', studentId);
    const recent_result = await getUpDownDetailAnalysis({'student_id':studentId,'nums':9999})
    console.log('getUpDownDetailAnalysis 响应:', recent_result);

    if (!recent_result || !recent_result.data) {
      console.warn('getUpDownDetailAnalysis did not return any data or returned null/undefined.');
      messageReturn.value = []; // Initialize to empty array if no data
      return;
    }
    messageReturn.value = recent_result.data;
    console.log('实际的考试数据结构:', recent_result.data);
    generateTable(recent_result.data,fieldMappingScore);
  } catch (error) {
    console.error('获取学生近期考试成绩失败:', error);
    messageReturn.value = []; // Ensure messageReturn is empty on error
  }
})

const generateTable = async (examData : any[], types: Object)=>{
  // 按考试ID升序排列：ID越小=越早的考试=图表最左边
  const sortedExamData = [...examData].sort((a, b) => {
    const idA = a.exam?.[0]?.id ?? 0;
    const idB = b.exam?.[0]?.id ?? 0;
    return idA - idB;
  });

  // 分开获取总分和各科成绩数组已经对应的考试名称

  const tempData: TempDataType = {
    '总分': {'x_name': [], 'y_score': []},
    '语文': {'x_name': [], 'y_score': []},
    '数学': {'x_name': [], 'y_score': []},
    '英语': {'x_name': [], 'y_score': []},
    '物理': {'x_name': [], 'y_score': []},
    '化学': {'x_name': [], 'y_score': []},
    '生物': {'x_name': [], 'y_score': []},
    '历史': {'x_name': [], 'y_score': []},
    '地理': {'x_name': [], 'y_score': []},
    '政治': {'x_name': [], 'y_score': []}
  }

  for(let item of sortedExamData) {
    if(item.exam === undefined) {
      message.error('似乎还没有参加一场考试');
      return
    }
    const examName = item.exam[0].name;
    console.log(item)
    // 获取该考试的特控线分数
    let passLine = null;
    const examId = item.exam[0].id;
    if (typeof examId !== 'number' || isNaN(examId)) {
      console.warn('Invalid exam ID in item:', item);
      continue; // Skip this item if exam ID is invalid
    }

    try {
      console.log('调用 getPassLine, exam_id:', examId);
      passLine = await getPassLine({'exam_id':examId});
      console.log('getPassLine 响应:', passLine);
    } catch (error) {
      console.error('获取特控线数据失败，考试ID:', examId, error);
    }
    
    // 处理特控线数据（行式：每行一个科目，按 line_group_id 分组聚合）
    let selectedPassLine = null;
    if (passLine && passLine.data && Array.isArray(passLine.data) && passLine.data.length > 0) {
      const passLineData = passLine.data;

      // 行式按 line_group_id 分组组装成 {科目: 分数} dict
      const groups = new Map<number, Record<string, number>>();
      passLineData.forEach((row: any) => {
        const gid = row?.line_group_id;
        if (gid == null) return;
        if (!groups.has(gid)) groups.set(gid, {});
        if (row.subject != null && row.score != null) {
          groups.get(gid)![row.subject] = row.score;
        }
      });

      // 查找最适合的特控线（根据学生是否有该科目成绩来判断）
      for (const [gid, lineDict] of groups) {
        let matchCount = 0;
        // 检查理科科目
        if (item['物理'] !== undefined || item['化学'] !== undefined || item['生物'] !== undefined) {
          if ((item['物理'] !== undefined && lineDict['物理'] !== undefined) ||
              (item['化学'] !== undefined && lineDict['化学'] !== undefined) ||
              (item['生物'] !== undefined && lineDict['生物'] !== undefined)) {
            matchCount++;
          }
        }
        // 检查文科科目
        if (item['历史'] !== undefined || item['政治'] !== undefined || item['地理'] !== undefined) {
          if ((item['历史'] !== undefined && lineDict['历史'] !== undefined) ||
              (item['政治'] !== undefined && lineDict['政治'] !== undefined) ||
              (item['地理'] !== undefined && lineDict['地理'] !== undefined)) {
            matchCount++;
          }
        }

        if (matchCount > 0) {
          selectedPassLine = lineDict;
          break;
        }
      }

      // 如果没有找到匹配的，就使用第一个
      if (!selectedPassLine) {
        selectedPassLine = groups.values().next().value || null;
      }
    } else if (passLine && passLine.data) {
      // 如果返回的是对象（已聚合）
      selectedPassLine = passLine.data;
    }

    // 处理总分 - 添加默认值处理
    tempData['总分']['x_name'].push(examName);
    tempData['总分']['y_score'].push({
      score: item['总分'] !== null ? item['总分'] : 0,
      line: selectedPassLine && selectedPassLine['总分'] !== undefined && selectedPassLine['总分'] !== null ? selectedPassLine['总分'] : 0,
    });

    // 处理各科目成绩 - 添加默认值处理
    for(const [subject, field] of Object.entries(types)) {
      tempData[subject]['x_name'].push(examName);
      tempData[subject]['y_score'].push({
        score: item[field] !== null ? item[field] : 0,
        line: selectedPassLine && selectedPassLine[field] !== undefined && selectedPassLine[field] !== null ? selectedPassLine[field] : 0,
      });
    }
  }
  totalData.value = tempData
  // 为每个科目生成图表配置
  options.value = subjects.map(subject => getSubjectOption(subject))
}

// 7. 查询成绩
const fetchData = async () => {
  console.log(options.value)
  if (mode.value === 'rank') {
    // 获取所有考试的特控线分数
    if (messageReturn.value) {
      generateTable(messageReturn.value,fieldMappingRank)
    }
  }
  else {
    // 获取所有考试的特控线分数
    if (messageReturn.value) {
      generateTable(messageReturn.value,fieldMappingScore)
    }
  }
}

const getSubjectOption = (subject: string) => {
  // 确保数据存在并处理null值
  const subjectData = totalData.value[subject] || { x_name: [], y_score: [] };
  const scores = subjectData.y_score?.map(d => d.score !== null ? d.score : 0) || [];
  const lines = subjectData.y_score?.map(d => d.line !== null ? d.line : 0) || [];

  // 为不同科目设置不同的颜色
  const colorMap: Record<string, string[]> = {
    '总分': ['#5470C6', '#EE6666'],
    '语文': ['#91CC75', '#EA7CCC'],
    '数学': ['#FAC858', '#73C0DE'],
    '英语': ['#EE6666', '#5470C6'],
    '物理': ['#73C0DE', '#FAC858'],
    '化学': ['#91CC75', '#EA7CCC'],
    '生物': ['#FAC858', '#73C0DE'],
    '历史': ['#EA7CCC', '#91CC75'],
    '地理': ['#5470C6', '#EE6666'],
    '政治': ['#73C0DE', '#FAC858']
  };
  
  const colors = colorMap[subject] || ['#5470C6', '#EE6666'];

  return {
    tooltip: { 
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      borderColor: '#ccc',
      borderWidth: 1,
      textStyle: {
        color: '#333'
      }
    },
    legend: { 
      data: ['本人成绩', '特控线'],
      top: '10%',
      textStyle: {
        color: '#666'
      }
    },
    xAxis: { 
      type: 'category', 
      data: subjectData.x_name || [],
      axisLabel: { 
        textStyle: {
          fontSize: 12,
          fontFamily: 'SimHei',
          color: '#666'
        }
      },
      axisLine: {
        lineStyle: {
          color: '#ddd'
        }
      }
     },
    yAxis: { 
      type: 'value',
      axisLabel: {
        textStyle: {
          color: '#666'
        }
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#eee'
        }
      }
    },
    series: [
      {
        name: '本人成绩',
        type: 'line',
        data: scores,
        itemStyle: { 
          color: '#1890ff',
          shadowColor: 'rgba(0, 0, 0, 0.1)',
          shadowBlur: 3
        },
        lineStyle: {
          width: 3,
          type: 'solid'
        },
        smooth: true,
        symbolSize: 6
      },
      {
        name: '特控线',
        type: 'line',
        data: lines,
        itemStyle: { 
          color: '#EE6666',
          shadowColor: 'rgba(0, 0, 0, 0.1)',
          shadowBlur: 3
        },
        lineStyle: {
          width: 3,
          type: 'dashed'
        },
        smooth: true,
        symbolSize: 6
      }
    ],
    grid: {
      left: '5%',
      right: '5%',
      top: '20%',
      bottom: '15%',
      containLabel: true
    }
  };
}


return (_ctx: any,_cache: any) => {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { class: "filter-card" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_radio_group, {
            value: mode.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((mode).value = $event)),
            style: {"margin":"0 12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: "rank" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("按名次", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: "score" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("按分数", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: fetchData
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("查询", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(subjects, (subject, index) => {
        return _createVNode(_component_a_card, {
          key: subject,
          class: "chart-card",
          bordered: false
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(studentName.value) + _toDisplayString(subject) + _toDisplayString(mode.value == 'rank' ? '历次排名':'成绩'), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(VChart), {
              option: options.value[index],
              autoresize: "",
              class: "chart-wrapper"
            }, null, 8, ["option"])
          ]),
          _: 2
        }, 1024)
      }), 64))
    ])
  ]))
}
}

})